<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <StoreRoleForm
      v-if="!isLoading"
      :storeRoleData="storeRoleData"
      :submitName="$t('edit')"
      v-on:addOrUpdateStoreRole="addOrUpdateStoreRole"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import StoreRoleForm from "@/components/settings/settingsOther/storeRoles/StoreRoleForm.vue";
import StoreRole from "@/models/settings/settingsOther/storeRoles/StoreRole";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "StoreRoleEdit",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    StoreRoleForm,
  },
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      storeRoleData: new StoreRole(),
      storeRoleToken: this.$route.params.storeRoleToken,
    };
  },
  methods: {
    async getStoreRoleDetails() {
      this.isLoading = true;
      this.storeRoleData.storeRoleToken = this.storeRoleToken;
      try {
        let response = await this.storeRoleData.getStoreRoleDetails(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.storeRoleData.fillData(response.data.storeRoleData);
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
          this.storeRoleData = null;
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
        this.storeRoleData = null;
      }
      this.isLoading = false;
    },
    async addOrUpdateStoreRole() {
      this.isLoading = true;
      try {
        let response = await this.storeRoleData.addOrUpdateStoreRole(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.$router.push("/store-roles");
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.getStoreRoleDetails();
  },
};
</script>

<style scoped lang="scss"></style>
